import {Action, ActionReducer, createReducer, on} from '@ngrx/store';
import * as HeartbeatActions from '../store-heartbeat/heartbeat.actions';

export interface HeartbeatState {
  isHeartbeatStarted: boolean;
  isInactivityTriggered: boolean;
  lastUserHeartBeat: number;
}

export const initialHeartBeatStateState: HeartbeatState = {
  isHeartbeatStarted: false,
  isInactivityTriggered: false,
  lastUserHeartBeat: undefined,
};

const createHeartbeatReducer: ActionReducer<HeartbeatState> = createReducer(
  initialHeartBeatStateState,
  on(HeartbeatActions.startHeartbeat, (state: HeartbeatState) => ({
    ...state,
    isInactivityTriggered: false,
    isHeartbeatStarted: true,
    lastUserHeartBeat: Date.now(),
  })),
  on(HeartbeatActions.heartBeatApplicationOnUserActivity, (state: HeartbeatState, {heartBeat}) => ({
    ...state,
    isInactivityTriggered: false,
    lastUserHeartBeat: heartBeat,
  })),
  on(HeartbeatActions.heartBeatInactivityTriggered, (state: HeartbeatState) => ({
    ...state,
    isInactivityTriggered: true,
  })),
);
//#endregion
export const heartbeatReducer = (state: HeartbeatState, action: Action): HeartbeatState => createHeartbeatReducer(state, action);
